import { render, staticRenderFns } from "./CompanyImporter.vue?vue&type=template&id=ff3b7136"
import script from "./CompanyImporter.vue?vue&type=script&lang=js"
export * from "./CompanyImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports